import { create } from 'zustand';

export interface BizyExternalOpenContext {
	source: string;
	pagePath: string;
	pageContext: string;
	starterMessage?: string;
	promptHint?: string;
}

interface BizyExternalOpenStore {
	pendingRequest: BizyExternalOpenContext | null;
	setPendingRequest: (request: BizyExternalOpenContext) => void;
	clearPendingRequest: () => void;
}

export const useBizyExternalOpenStore = create<BizyExternalOpenStore>((set) => ({
	pendingRequest: null,
	setPendingRequest: (request) => set({ pendingRequest: request }),
	clearPendingRequest: () => set({ pendingRequest: null }),
}));
